import React from 'react';
import { useLocation } from 'react-router';
import { useGetUserSurveyResponseQuery } from '../../app/surveyApi/surveyApi';
import Loader from '../../components/shared/loader/Loader';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import { useParams } from 'react-router';
const SubmittedAnwers = () => {
    const {id:userId} = useParams()
    const location = useLocation();
    const surveyId = location.state?.surveyId;
    const leadId = location.state?.leadId;

    const { data: AnswerDta, isLoading } = useGetUserSurveyResponseQuery({userId, surveyId,leadId });
console.log(AnswerDta,"AnswerDta")
    if (isLoading) {
        return (
            <Loader />
        );
    }

    return (
        <div>
            <div className='d-flex gap-3 mb-4'>
                <img
                    alt="survey"
                    className="rounded"
                    width="60"
                    height="60"
                    src={AnswerDta?.data?.survey_image}
                />
                <div>
                    <h2 className='cmn_heading'>{AnswerDta?.data?.title}</h2>
                    <p className='sr-desc'>{AnswerDta?.data?.description}</p>
                </div>
            </div>

            <ul className='p-0 d-flex gap-3 flex-column'>
                {AnswerDta?.data?.responses?.map((ans, index) => {
                    const isMediaType = ['image', 'video', 'file'].includes(ans?.questionType);

                    return (
                        <li key={index} className='quesions p-3'>
                            <p className='ques-title my-2 ' ><strong>{ans.question}</strong></p>

                            {!isMediaType && ans?.questionType !== 'multiSelect' && ans?.questionType !== 'compass' && (
                                <p className=' ques-type' >
                                    {ans?.answer === null || ans?.answer === undefined
                                        ? 'No answer'
                                        : typeof ans?.answer === 'boolean'
                                            ? ans.answer ? 'Yes' : 'No'
                                            : String(ans.answer)}
                                </p>
                            )}
{ans?.userComment && (
                                <p className=' ques-type' >
                                   dcdcdc {ans?.userComment}
                                </p>
)}
                            {ans?.questionType === 'multiSelect' && Array.isArray(ans?.answer) && (
                                <ul className='ps-0'>
                                    {ans.answer.map((multiAns, idx) => (
                                        <li className='inline-disc' key={idx}>{multiAns}</li>
                                    ))}
                                </ul>
                            )}

                            {ans?.questionType === 'image' && Array.isArray(ans?.answer) &&
                                ans.answer.map((img, idx) => (
                                    <div key={idx} style={{ marginBottom: '10px' }}>
                                        <PhotoProvider>
                                            <PhotoView src={img}>
                                                <img
                                                    className='img-fluid object-fit-cover'
                                                    height={200}
                                                    width={200}
                                                    src={img}
                                                    alt={`Answer ${idx + 1}`}

                                                />
                                            </PhotoView>


                                        </PhotoProvider>
                                    </div>
                                ))
                            }

                            {ans?.questionType === 'compass' && (
                                <>
                                    <span>{ans?.answer?.heading}</span>
                                    <span>{ans?.answer?.label}</span>
                                </>
                            )}

                            {ans?.questionType === 'video' && ans?.answer && (
                                <div style={{ marginBottom: '10px' }}>
                                    <video controls style={{ maxWidth: "100%" }}>
                                        <source src={ans.answer} type="video/mp4" />
                                        Your browser does not support the video tag.
                                    </video>
                                </div>
                            )}

                            {ans?.questionType === 'file' && ans?.answer && (
                                <div style={{ marginTop: '10px' }}>
                                    <a
                                        href={ans.answer}
                                        download
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ textDecoration: 'underline', color: '#007bff' }}
                                    >
                                        📎 Download File
                                    </a>
                                </div>
                            )}

                            {ans?.repeatAnswers?.length > 0 && (
                                <div className="repeat-wrapper mt-2">
                                    
                                    {ans.repeatAnswers.map((group, gIndex) => (
                                        <div key={gIndex} className="repeat-block  mb-2 rounded">
                                            
                                            {group.answers.map((subAns, sIndex) => {
                                                const isImage = subAns.questionType === "image";
                                                const isVideo = subAns.questionType === "video";
                                                const isFile = subAns.questionType === "file";
                                                const isMedia = isImage || isVideo || isFile;

                                              const renderAnswer = () => {
                                            const answer = subAns.answer;

                                            if (answer === null || answer === undefined) {
                                                return "No answer";
                                            }

                                            if (typeof answer === "boolean") {
                                                return answer ? "Yes" : "No";
                                            }

                                            if (typeof answer === "object") {
                                                const values = Object.values(answer);

                                                // If object has only one property, return its value
                                                if (values.length === 1) {
                                                return String(values[0]);
                                                }

                                                // If multiple properties, show key: value pairs
                                                return Object.entries(answer)
                                                .map(([key, value]) => `${key}: ${value}`)
                                                .join(", ");
                                            }

                                            return String(answer);
                                            };
                                                
                                                return (
                                                    <div key={sIndex} className="mb-2 repeated-answers">
                                                        <strong>{subAns.question}</strong>

                                                        {subAns?.questionType === 'compass' && (
                                                            <div>
                                                                <span>{subAns?.answer?.heading}</span>
                                                                <span>{subAns?.answer?.label}</span>
                                                            </div>
                                                        )}
                                                        <PhotoProvider>
                                                            {isImage && Array.isArray(subAns.answer) && (
                                                                <div className="mt-1 d-flex flex-wrap gap-2">
                                                                    {subAns.answer.map((imgUrl, i) => (
                                                                        <PhotoView src={imgUrl}>
                                                                            <img
                                                                              className='img-fluid object-fit-cover'
                                                                                width={"200"}
                                                                                height={"200"}
                                                                                key={i}
                                                                                src={imgUrl}
                                                                                alt="uploaded"

                                                                            />


                                                                        </PhotoView>

                                                                    ))}
                                                                </div>
                                                            )}
                                                        </PhotoProvider>

                                                        {isVideo && subAns.answer && (
                                                            <video width="220" height="160" controls className="mt-2">
                                                                <source src={subAns.answer} type="video/mp4" />
                                                                Your browser does not support the video tag.
                                                            </video>
                                                        )}

                                                        {isFile && subAns.answer && (
                                                            <div className="mt-1">
                                                                <a href={subAns.answer} target="_blank" rel="noopener noreferrer" download>
                                                                    Download File
                                                                </a>
                                                            </div>
                                                        )}

                                                        {!isMedia && subAns?.questionType !== 'multiSelect' && subAns?.questionType !== 'compass' && (
                                                            <p className="m-0 ques-type mt-1">{renderAnswer()}</p>
                                                        )}
                                                        {ans?.userComment && (
                                <p className=' ques-type pt-2' >
                                   Comment: {ans?.userComment}
                                </p>
)}
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default SubmittedAnwers;
